import { render, staticRenderFns } from "./invoiceItemsTablePrint.vue?vue&type=template&id=1015856f&"
import script from "./invoiceItemsTablePrint.vue?vue&type=script&lang=ts&"
export * from "./invoiceItemsTablePrint.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports